import React, { useEffect, useState } from "react";
import BackPage from "../components/BackPage";
import { useNavigate, useParams } from "react-router-dom";
import CardThumb from "../components/CardThumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import Newsletter from "../components/Newsletter";
import { Loading } from "common/pages";
import "./Event.scss";

export default function Event({ account, setAccount, api }) {
  const navigate = useNavigate();
  const { eventId } = useParams();

  const [card, setCard] = useState({});
  const [loading, setLoading] = useState(true);
  const [limitContent, setLimitContent] = useState(6);
  const [similarCards, setSimilarCards] = useState([]);
  const [dataSize, setDataSize] = useState(1);

  const callbackFavorite = {
    favorited: (cardId) => {
      setSimilarCards(prev => {
        return prev.map((cardItem) => {
          if (cardItem.id === cardId) cardItem.favorited = true
          return cardItem
        })
      })

      setAccount({ ...account, favorite_count: account.favorite_count + 1 })
    },
    unFavorited: (cardId) => {
      setSimilarCards(prev => {
        return prev.map((cardItem) => {
          if (cardItem.id === cardId) cardItem.favorited = false
          return cardItem
        })
      })

      setAccount({ ...account, favorite_count: account.favorite_count - 1 })
    },
    favoritedUniq: (favorited) => {
      setCard(prev => ({ ...prev, favorited }))
      setAccount({ ...account, favorite_count: favorited ? account.favorite_count + 1 : account.favorite_count - 1 })
    },
  }

  useEffect(() => {
    setLoading(true);

    if (!eventId) {
      navigate("/404");
    }

    api(`api/providers/${process.env.REACT_APP_SLUG}/content-videos/${eventId}/`,)
      .then(({ ok, body }) => {
        if (ok) setCard(body.data);
        setLoading(false);
      });
  }, [api, setLoading, setCard, eventId, navigate]);

  useEffect(() => {
    if (card.id) {
      const topics = card.topics && card.topics.length ? card.topics[0].name : "" 
      api(`api/providers/${process.env.REACT_APP_SLUG}/content-videos/?page=1&page_size=${limitContent}&topics=${topics}&exclude=${card.id}`)
        .then(({ ok, body }) => {
          if (ok) {
            setSimilarCards(body.data);
            setDataSize(body.data_size)
          }
        });
    }
  }, [card, api, setSimilarCards, limitContent]);

  return (
    <>
      <div className={`event-page wrapper-login ${loading ? "loading" : ""}`}>
        {!loading ? (
          <>
            <div className="bw-event-container">
                <BackPage />

                <div className="wrapper-card pb-5">
                  <CardThumb api={api} logged={!!account} isFull={true} card={card} callbackFavorite={callbackFavorite} />
                </div>
              </div>
              <section className="others bw-event-bg-light py-5">
                <div className="bw-event-container">
                  <h2 className="bw-event-title">Other videos in this topic</h2>
                  
                  <div className="bw-event-row pt-4">
                    {similarCards.slice(0, limitContent).map((item, key) => (
                      <div className="bw-event-col" key={key}>
                        <CardThumb api={api} logged={!!account} card={item} callbackFavorite={callbackFavorite} />
                      </div>
                    ))}
                  </div>

                  {limitContent < dataSize ? (
                    <button
                      className="bw-event-btn bw-event-btn-more"
                      onClick={() => setLimitContent(limitContent + 3)}
                    >
                      Show more
                      <FontAwesomeIcon
                        icon={faChevronRight}
                        style={{ color: "#1976D2" }}
                      />
                    </button>
                  ) : null}
                </div>
              </section>
              <Newsletter />
          </>
        ) : <Loading />}
      </div>
    </>
  );
}
